import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge } from '@ui/primitives';
import { useMemo } from 'react';
import { TableVirtualizer } from '../TableVirtualizer';
import { configureColumnDefs, convertToRowData } from './helper';
export const ModuleInfo = (props)=>{
    var _appModule_requires;
    const { organization, project, application, appModule } = props;
    const columnDefs = useMemo(()=>configureColumnDefs(organization, project, application), [
        application,
        organization,
        project
    ]);
    const rowData = useMemo(()=>convertToRowData(appModule), [
        appModule
    ]);
    // Type-safe access to dynamic properties
    const file = appModule.file;
    const requires = (_appModule_requires = appModule.requires) !== null && _appModule_requires !== void 0 ? _appModule_requires : [];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            file && /*#__PURE__*/ _jsxs("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "font-inter font-bold text-lg mb-4 text-foreground",
                        children: "File"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "p-4 bg-card rounded-lg",
                        children: file
                    })
                ]
            }),
            requires.length > 0 && /*#__PURE__*/ _jsxs("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "font-inter font-bold text-lg mb-4 text-foreground",
                        children: "Requires"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "p-4 pb-2 bg-card rounded-lg flex flex-wrap gap-2",
                        children: requires.map((require)=>/*#__PURE__*/ _jsx(Badge, {
                                variant: "secondary",
                                children: require
                            }, require))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "font-inter font-bold text-lg mb-4 text-foreground",
                        children: "Used By"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-[340px]",
                        children: /*#__PURE__*/ _jsx(TableVirtualizer, {
                            data: rowData,
                            columns: columnDefs
                        })
                    })
                ]
            })
        ]
    });
};
